module.exports = __webpack_public_path__ + "img/20200102154958998.c89905ed.jpg";